import { j as o, c as e } from "./utils-BdNIfrGQ.js";
import { n as r } from "./normalize-gap-CHOQjV8I.js";
import { D as i } from "./Div-spVpsZsH.js";
const l = ({ gap: s, className: a, ...m }) => /* @__PURE__ */ o.jsx(i, { className: e(a, "flex", r(s)), ...m });
l.displayName = "Flex";
export {
  l as F
};
